<div class="page-container neo-ds BMW d-flex flex-column">
  <app-newsletter-header />
  <div class="page-panel-container neo-ds BMW" [class.d-none]="!isLoading()">
    <neo-loader brand="BMW" color="SECONDARY" size="50" center> </neo-loader>
    <p class="neo-heading-body-1 mt-32 text-center" [innerHTML]="'loading_message' | translate"></p>
  </div>
  <div class="page-panel-container" [class.mobile]="isPhoneOrTablet()" [class.d-none]="isLoading()">
    <router-outlet></router-outlet>
  </div>
  <app-newsletter-footer class="mt-auto" />
</div>
